export enum SearchGroupNames {
  Admin = 'admin',
  Careers = 'careers',
  Companies = 'companies',
  Education = 'education',
  Locations = 'locations',
  People = 'people',
  Skills = 'skills',
}